import React from 'react';

export default function WhatsAppButton({ phone = '525500000000', message = 'Hola, vengo de MisXV.com.mx' }) {
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="whatsapp-fab" aria-label="Contactar por WhatsApp">
      💬
    </a>
  );
}
